import { colors, alphaVar } from "../colors";
import { mt, pt } from "date-fns/locale";

export const SASOutlinedBase = {
  borderRadius: "14px",
  backgroundColor: "var(--fx-surface-base, #FFFFFF)",

  "& fieldset": {
    borderColor: colors.orange.base,
    borderWidth: "1px",
  },

  "&:hover fieldset": {
    borderColor: colors.orange[200],
  },

  "&.Mui-focused fieldset": {
    borderColor: colors.orange.base,
    boxShadow: `0 0 0 2px ${alphaVar(colors.orange[200], 0.35)}`,
  },

  "&.Mui-error fieldset": {
    borderColor: colors.danger.base,
  },

  "&.Mui-error.Mui-focused fieldset": {
    borderColor: colors.danger[700],
    boxShadow: `0 0 0 2px ${alphaVar(colors.danger[200], 0.55)}`,
  },
};

export const inputStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    "& fieldset": {
      borderColor: colors.orange[200],
      borderWidth: "2px",
    },
    "&:hover fieldset": {
      borderColor: colors.orange[400],
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.orange.base,
    },
    "&.Mui-error fieldset": {
      borderColor: colors.danger.base,
    },
    "&.Mui-error:hover fieldset": {
      borderColor: colors.danger.base,
    },
    "&.Mui-error.Mui-focused fieldset": {
      borderColor: colors.danger[700],
    },
  },
  "& .MuiInputLabel-root": {
    color: colors.gray[400],
    "&.Mui-focused": {
      color: colors.orange.base,
    },
    "&.Mui-error": {
      color: colors.danger.base,
    },
  },
};

export const SASInputStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    paddingX: "4px",
    paddingY: "4px",
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    "& fieldset": {
      borderColor: colors.orange.base,
      borderWidth: "1px",
    },
    "&:hover fieldset": {
      borderColor: colors.orange[200],
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.orange.base,
      boxShadow: `0 0 0 2px ${colors.orange[200]}33`,
    },
    "&.Mui-error fieldset": {
      borderColor: colors.danger.base,
    },
    "&.Mui-error.Mui-focused fieldset": {
      borderColor: colors.danger[700],
      boxShadow: `0 0 0 2px ${colors.danger[200]}55`,
    },
  },

  "& .MuiInputLabel-root": {
    color: colors.gray[400],
    fontWeight: 500,
    "&.Mui-focused": {
      color: colors.orange.base,
    },
    "&.Mui-error": {
      color: colors.danger.base,
    },
  },

  "& input": {
    padding: "12px 14px",
    fontSize: "1.0rem",
    color: colors.gray.base,
  },
};

export const SASSelectStyles = {
  mt: "3px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    minHeight: 48,
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.orange.base,
    borderWidth: "1px",
  },

  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.orange[200],
  },

  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.orange.base,
    boxShadow: `0 0 0 2px ${alphaVar(colors.orange[200], 0.35)}`,
  },

  "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.danger.base,
  },

  "& .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.danger[700],
    boxShadow: `0 0 0 2px ${alphaVar(colors.danger[200], 0.55)}`,
  },

  "& .MuiSelect-select": {
    padding: "12px 14px",
    fontSize: "1rem",
    lineHeight: "1.4",
    display: "flex",
    alignItems: "center",
    color: colors.gray.base,
  },

  "& .MuiSvgIcon-root": {
    color: colors.orange.base,
  },
};

export const SASButtonStyles = {
  borderRadius: "8px",
  padding: "8px 20px",
  fontWeight: 600,
  fontSize: "0.85rem",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  backgroundColor: colors.orange.base,
  color: "#fff",
  boxShadow: `0 2px 4px ${colors.orange[200]}80`,
  transition: "all 0.2s ease-in-out",

  "&:hover": {
    backgroundColor: colors.orange[600],
    boxShadow: `0 4px 8px ${colors.orange[300]}80`,
  },

  "&:disabled": {
    backgroundColor: colors.gray[100],
    color: colors.gray[300],
    boxShadow: "none",
  },
};

export const SASSwitchStyles = {
  "& .MuiSwitch-switchBase": {
    color: colors.gray[300],

    "&.Mui-checked": {
      color: colors.orange.base,
      "& + .MuiSwitch-track": {
        backgroundColor: colors.orange[200],
        opacity: 1,
      },
    },

    "&.Mui-checked:hover": {
      backgroundColor: `${colors.orange[200]}33`,
    },

    "&.Mui-disabled": {
      color: colors.gray[200],
      "& + .MuiSwitch-track": {
        backgroundColor: colors.gray[100],
        opacity: 0.5,
      },
    },
  },

  "& .MuiSwitch-thumb": {
    width: 20,
    height: 20,
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },

  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: colors.gray[200],
    opacity: 1,
    transition: "all 0.3s ease-in-out",
  },
};

export const SASMenuStyles = {
  zIndex: 999999999,
  "& .MuiPaper-root": {
    borderRadius: 2,
    mt: 1,
    minWidth: 220,
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    border: `1px solid ${colors.orange[100]}`,
  },
  "& .MuiMenuItem-root": {
    fontSize: "0.9rem",
    fontWeight: 500,
    color: colors.gray[800],
    "&:hover": {
      bgcolor: colors.orange[50],
      color: colors.orange[600],
      "& .MuiListItemIcon-root": {
        color: colors.orange.base,
      },
    },
    "&.Mui-selected": {
      bgcolor: alphaVar(colors.orange.base, 0.1),
      color: colors.orange[700],
    },
  },
  "& .MuiListItemIcon-root": {
    color: colors.gray[400],
    minWidth: 36,
  },
};

export const SASSelectMenuStyles = {
  borderRadius: "12px",
  fontSize: "0.8rem",
  fontWeight: 400,
  color: colors.gray[400],
  backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
  height: 28,
  minWidth: 0,

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.gray[200],
    transition: "border-color 0.2s",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.gray[300],
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.orange.base,
    boxShadow: `0 0 0 1px ${alphaVar(colors.orange.base, 0.18)}`,
  },

  "& .MuiSelect-select": {
    padding: "0px 24px 0px 12px",
    display: "flex",
    alignItems: "center",
    fontSize: "0.75rem",
    height: "28px",
    boxSizing: "border-box",
    color: colors.gray[500],
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1rem",
    color: colors.gray[500],
    right: 8,
    position: "absolute",
  },
  "&.Mui-focused .MuiSvgIcon-root": {
    color: colors.orange.base,
  },

  "& ~ .MuiInputLabel-root": {
    color: colors.gray[400],
    fontSize: "0.75rem",
    transform: "translate(14px, 6px) scale(1)",
    "& ~ .MuiInputLabel-root.Mui-focused": {
      color: `${colors.gray[400]} !important`,
    },
    "& ~ .MuiInputLabel-root.MuiInputLabel-shrink": {
      color: colors.gray[400],
      transform: "translate(14px, -8px) scale(0.85)",
      backgroundColor: "var(--fx-surface-base, #FFFFFF)",
      padding: "0 4px",
    },
  },
};

export const SASSelectMenuStylesSmall = {
  ...SASSelectMenuStyles,

  fontSize: "0.65rem",
  height: 24,
  width: "fit-content",

  "& .MuiSelect-select": {
    padding: "4px 28px 4px 12px",
    display: "flex",
    alignItems: "center",
  },

  "& .MuiSvgIcon-root": {
    fontSize: "0.85rem",
    right: 8,
  },
};

export const SASDashboardSelectStyles = {
  ...SASSelectMenuStyles,
  height: 30,
  borderRadius: "8px",
  backgroundColor: "var(--fx-surface-base, #FFFFFF)",
  color: colors.gray[500],
  fontWeight: 700,
  boxShadow: "0 1px 3px rgba(15, 23, 42, 0.04)",

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: alphaVar(colors.gray[100], 0.9),
    transition: "border-color 0.2s, box-shadow 0.2s, background-color 0.2s",
  },
  "&:hover": {
    backgroundColor: alphaVar(colors.orange.base, 0.035),
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: alphaVar(colors.orange.base, 0.35),
  },
  "&.Mui-focused": {
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.orange.base,
    boxShadow: `0 0 0 2px ${alphaVar(colors.orange.base, 0.12)}`,
  },

  "& .MuiSelect-select": {
    padding: "0px 26px 0px 12px",
    display: "flex",
    alignItems: "center",
    fontSize: "0.72rem",
    fontWeight: 700,
    height: "30px",
    boxSizing: "border-box",
    color: colors.gray[500],
  },
  "& .MuiSvgIcon-root": {
    fontSize: "0.95rem",
    color: colors.gray[400],
    right: 8,
    position: "absolute",
  },
  "&.Mui-focused .MuiSvgIcon-root": {
    color: colors.orange.base,
  },
};

/** @type {import('@mui/material').MenuProps} */
export const SASSMenuPropsStyles = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  PaperProps: {
    sx: {
      mt: 0,
      borderRadius: "12px",
      minWidth: 140,
      backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
      boxShadow: `0 2px 8px ${alphaVar(colors.gray[900], 0.12)}`,
      border: `1px solid ${colors.gray[200]}`,

      "& .MuiMenuItem-root": {
        fontSize: "0.8rem",
        fontWeight: 400,
        color: colors.gray[400],
        borderRadius: 1,
        mx: 0.5,
        my: 0.25,

        "&:hover": {
          backgroundColor: alphaVar(colors.gray[200], 0.5),
          color: colors.gray[900],
        },

        "&.Mui-selected": {
          backgroundColor: alphaVar(colors.orange.base, 0.12),
          color: colors.orange.base,
        },

        "&.Mui-selected:hover": {
          backgroundColor: alphaVar(colors.orange.base, 0.18),
        },
      },
    },
  },
};

export const SASSMenuPropsStylesSmall = {
  ...SASSMenuPropsStyles,

  PaperProps: {
    ...SASSMenuPropsStyles.PaperProps,
    sx: {
      ...SASSMenuPropsStyles.PaperProps.sx,

      minWidth: 120,

      "& .MuiMenuItem-root": {
        ...SASSMenuPropsStyles.PaperProps.sx["& .MuiMenuItem-root"],

        fontSize: "0.7rem",
        mx: 0.4,
        my: 0.2,
        minHeight: 26,
      },
    },
  },
};
